import { render, staticRenderFns } from "./HistoryResults.vue?vue&type=template&id=97afc77c&scoped=true&"
import script from "./HistoryResults.vue?vue&type=script&lang=js&"
export * from "./HistoryResults.vue?vue&type=script&lang=js&"
import style0 from "./HistoryResults.vue?vue&type=style&index=0&id=97afc77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97afc77c",
  null
  
)

export default component.exports